module.exports = [
    { label: "List", value: 0 },
    { label: "Square Thumbnail", value: 1 },
    { label: "Rounded Thumbnail", value: 2 },
    { label: "Circle Thumbnail", value: 3 },
    { label: "Show Cards on Main Page", value: 4 },
    // { label: "Show Cards on Click", value: 5 },
    { label: "Show List on Click", value: 5 },
    { label: "Show Collection on Main Page", value: 6 },
    { label: "Show Collection on Click", value: 7 },
]